export default __webpack_public_path__ + "static/media/s663.702bc554.png";